import { Link } from "react-router-dom";

export default function ProductsTab() {
  // Example data (replace with API data)
  const products = [
    {
      id: 1,
      name: "A Walk Amongst Friends - Canvas Print",
      image:
        "https://images.pexels.com/photos/1269968/pexels-photo-1269968.jpeg",
      price: 10.24,
      quantity: 1,
    },
    {
      id: 2,
      name: "Lago di Braies - Canvas Print",
      image: "https://images.pexels.com/photos/889839/pexels-photo-889839.jpeg",
      price: 24.62,
      quantity: 1,
    },
    {
      id: 3,
      name: "Never Stop Changing - Canvas Print",
      image:
        "https://images.pexels.com/photos/1532704/pexels-photo-1532704.jpeg",
      price: 49.29,
      quantity: 1,
    },
  ];

  return (
    <div className="w-full max-w-3xl overflow-x-auto bg-dry border border-border rounded-lg shadow-sm">
      <table className="min-w-full text-sm text-left text-gray-700">
        <thead className="bg-border text-text uppercase text-xs font-semibold border-b">
          <tr>
            <th className="p-3">ID</th>
            <th className="p-3">Image</th>
            <th className="p-3">Name</th>
            <th className="p-3 text-right">Price</th>
            <th className="p-3 text-right">Quantity</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr
              key={p.id}
              className="border-t border-border hover:bg-border transition-colors text-text"
            >
              <td className="p-3 font-medium">{p.id}</td>
              <td className="p-3">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-14 h-20 object-cover rounded shadow-sm border"
                />
              </td>
              <td className="p-3">
                <Link
                  to="#"
                  className="text-redlight hover:text-reddark underline"
                >
                  {p.name}
                </Link>
              </td>
              <td className="p-3 text-right font-medium">
                ${p.price.toFixed(2)}
              </td>
              <td className="p-3 text-right">{p.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// import Typography from '@mui/material/Typography';
// import { Link, useParams } from 'react-router-dom';
// import { useGetECommerceOrderQuery } from '../../ECommerceApi';

// /**
//  * The products tab.
//  */
// function ProductsTab() {
// 	const routeParams = useParams();
// 	const { orderId } = routeParams;
// 	const { data: order } = useGetECommerceOrderQuery(orderId, {
// 		skip: !orderId
// 	});
// 	return (
// 		<div className="w-full max-w-3xl  table-responsive border rounded-md">
// 			<table className="simple dense">
// 				<thead>
// 					<tr>
// 						<th>
// 							<Typography className="font-semibold">ID</Typography>
// 						</th>
// 						<th>
// 							<Typography className="font-semibold">Image</Typography>
// 						</th>
// 						<th>
// 							<Typography className="font-semibold">Name</Typography>
// 						</th>
// 						<th>
// 							<Typography className="font-semibold">Price</Typography>
// 						</th>
// 						<th>
// 							<Typography className="font-semibold">Quantity</Typography>
// 						</th>
// 					</tr>
// 				</thead>
// 				<tbody>
// 					{order?.products?.map((product) => (
// 						<tr key={product.id}>
// 							<td className="w-64">{product.id}</td>
// 							<td className="w-80">
// 								<img
// 									className="product-image"
// 									src={product.image}
// 									alt="product"
// 								/>
// 							</td>
// 							<td>
// 								<Typography
// 									component={Link}
// 									to={`/apps/e-commerce/products/${product.id}`}
// 									className="truncate"
// 									style={{
// 										color: 'inherit',
// 										textDecoration: 'underline'
// 									}}
// 								>
// 									{product.name}
// 								</Typography>
// 							</td>
// 							<td className="w-64 text-right">
// 								<span className="truncate">${product.price}</span>
// 							</td>
// 							<td className="w-64 text-right">
// 								<span className="truncate">{product.quantity}</span>
// 							</td>
// 						</tr>
// 					))}
// 				</tbody>
// 			</table>
// 		</div>
// 	);
// }

// export default ProductsTab;
